import { useCallback, useRef } from 'react'

import GustoAddress from '../GustoAddress'
import {
  POST_CREATE_COMPANY_LOCATION_KEY,
  postCreateCompanyLocation,
} from '../payrollActions'
import { PayrollError } from '../PayrollError'
import { Button, Dialog } from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'

export const WorkAddressModal = ({
  closeModal,
  open,
}: {
  closeModal: () => void
  open: boolean
}) => {
  const dispatch = useAppDispatch()
  const addressRef = useRef<GustoAddress>(null)

  const addAddress = useCallback(async () => {
    const address = addressRef.current?.getAddressWithPhone()
    if (!address) {
      return
    }

    const res = await postCreateCompanyLocation({
      ...address,
      filing_address: false,
      mailing_address: false,
    })(dispatch)

    if (res) {
      closeModal()
    }
  }, [closeModal, dispatch])

  return (
    <Dialog open={open} onOpenChange={closeModal} onClose={closeModal}>
      <Dialog.Content className="max-w-md">
        <Dialog.Title>Add New Location</Dialog.Title>
        <div className="space-y-2 mt-4">
          <PayrollError fetchKey={POST_CREATE_COMPANY_LOCATION_KEY} />
          <GustoAddress ref={addressRef} />
        </div>
        <Dialog.Footer className="mt-4 flex flex-col sm:flex-row">
          <Button onClick={addAddress}>Add New Location</Button>
          <Button onClick={closeModal} variant="secondary">
            Cancel
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
